import { ReactComponent as EyeIcon } from "components/icons/grey-eye.svg";
import { ReactComponent as CrossEyeIcon } from "components/icons/cross-grey-eye.svg";
import classes from "./TogglePasswordButton.module.scss";

interface IProps {
  onClick: () => void;
  isShow: boolean;
}

export const TogglePasswordButton = ({ onClick, isShow }: IProps) => {
  return (
    <button
      className={classes.Button}
      type="button"
      aria-label="toggle password visibility"
      onClick={onClick}
    >
      {isShow ? <EyeIcon /> : <CrossEyeIcon />}
    </button>
  );
};
